import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { join, concat, cond, equals, T } from 'ramda'

import Dropzone from 'react-dropzone'
import filesize from 'filesize'
import Progress from 'react-progressbar'

import './media-upload.css'

import TweetLimitations from './limitations/tweet'
import OverlayLimitations from './limitations/overlay'
import MosaicLimitations from './limitations/mosaic'

const imageTypes = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp'
]

const videoTypes = ['video/mp4', 'video/quicktime', 'video/mov']

const OVERLAY_GIF = ['image/gif']
const OVERLAY_IMAGE = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp']
const MOSAIC_OPT_IN = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp']

const getValidMediaTypes = value =>
  cond([
    [equals('OVERLAY_GIF'), () => join(', ', OVERLAY_GIF)],
    [equals('OVERLAY_IMAGE'), () => join(', ', OVERLAY_IMAGE)],
    [equals('MOSAIC_OPT_IN'), () => join(', ', MOSAIC_OPT_IN)],
    [T, () => join(', ', concat(imageTypes, videoTypes))]
  ])(value)

const getLimitations = actionType => {
  switch (actionType) {
    case 'OVERLAY_GIF':
    case 'OVERLAY_IMAGE':
      return <OverlayLimitations />
    case 'MOSAIC_OPT_IN':
      return <MosaicLimitations />
    default:
      return <TweetLimitations />
  }
}
export const FileItem = ({ file, onRemove }) => {
  const preview = file.type.startsWith('video') ? (
    <video src={file.preview} alt='Preview' width={90} />
  ) : (
    <img src={file.preview} alt='Preview' width={80} />
  )

  return (
    <div key={file.name} className='br-upload-render'>
      <div className='br-upload-icon'>
        <div className='br-upload-icon'>{preview}</div>
      </div>
      <div className='br-upload-container'>
        <div className='br-upload-info'>
          <div className='br-upload-name' title={file.name}>
            {file.name}
          </div>
          <div className='br-upload-remove' onClick={onRemove}>
            <i className='fa fa-times-circle' />
          </div>
        </div>
        <div className='br-upload-progress'>
          <Progress completed={file.progress} />
          <div className='br-upload-progress-info'>
            <div className='br-upload-progress-amount'>
              {file.error ? (
                <div className='br-file-error'>{file.error}</div>
              ) : (
                `${file.progress || 0}% done`
              )}
            </div>
            <div className='br-upload-size'>{filesize(file.size)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

FileItem.propTypes = {
  file: PropTypes.object,
  onRemove: PropTypes.func
}

const MediaUploadModal = ({
  show,
  imageTypes,
  videoTypes,
  dropzoneActive,
  error,
  files,
  actionType,

  onHide,
  onRemove,
  onDrop,
  onMouseEnter,
  onMouseLeave,
  onSave
}) => {
  return (
    <Modal show={show} onHide={onHide} className='br-media-upload'>
      <Modal.Header closeButton>
        <Modal.Title>Upload Media</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Dropzone
          multiple
          accept={getValidMediaTypes(actionType)}
          rejectClassName='br-rejected'
          onDrop={onDrop}
          onDragEnter={onMouseEnter}
          onDragLeave={onMouseLeave}
          onMouseLeave={onMouseLeave}
          maxSize={1073741824} // bytes == 1GB
          className={'br-upload-area' + (dropzoneActive ? ' active' : '')}
        >
          <i className='fa fa-cloud-upload' />
          <h4>DRAG & DROP FILES HERE</h4>
          <p>or</p>
          <div className='br-btn'>Browse files</div>
        </Dropzone>
        <div className='br-file-list'>
          {error && <div className='br-upload-error'>{error}</div>}
          <div className='br-media-file'>
            {files.map((file, i) => (
              <FileItem
                file={file}
                key={file.name}
                onRemove={() => onRemove(i)}
              />
            ))}
          </div>

          {files.length ? (
            <div
              className={
                `br-btn pull-right` +
                (files.some(file => file.error) ? ' br-disabled' : '')
              }
              onClick={onSave}
            >
              Save & insert media
            </div>
          ) : null}
        </div>
        {getLimitations(actionType)}
      </Modal.Body>
    </Modal>
  )
}

MediaUploadModal.defaultProps = {
  imageTypes,
  videoTypes,
  files: [],
  error: '',
  show: false
}

MediaUploadModal.propTypes = {
  show: PropTypes.bool,
  dropzoneActive: PropTypes.bool,
  error: PropTypes.string,
  files: PropTypes.array,
  actionType: PropTypes.string,

  onHide: PropTypes.func,
  onRemove: PropTypes.func,
  onDrop: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onSave: PropTypes.func,
  imageTypes: PropTypes.array,
  videoTypes: PropTypes.array
}

export default MediaUploadModal



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-upload/media-upload.js